import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import { CallbackService } from '../services/CallbackService';

/** True when the CustomerCallback flag is on and the callback queue currently accepts requests. */
export const useCallbackQueueOpen = (): boolean => {
    const { CustomerCallback } = useAppSelector((state: RootState) => state.app.serviceInfo.featureFlags);
    const hostContext = useAppSelector((state: RootState) => state.hostContext.hostContext);
    const token = useAuth().user?.access_token;
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!token || !CustomerCallback) {
            setIsOpen(false);
            return;
        }

        let cancelled = false;
        const checkQueueStatus = async () => {
            try {
                const queueStatus = await new CallbackService(token).getQueueStatusAsync(hostContext);
                if (!cancelled) {
                    setIsOpen(queueStatus.status === 'Open');
                }
            } catch {
                if (!cancelled) {
                    setIsOpen(false);
                }
            }
        };

        void checkQueueStatus();
        return () => {
            cancelled = true;
        };
    }, [token, CustomerCallback, hostContext]);

    return CustomerCallback && isOpen;
};
